import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M2079 10728 c-27 -50 21 -238 102 -399 91 -182 199 -331 347 -481 47
-49 82 -88 78 -88 -13 0 -209 134 -341 234 -165 123 -235 181 -489 400 -165
143 -229 183 -272 172 -78 -20 -43 -227 74 -431 49 -85 172 -234 250 -304 37
-32 81 -71 97 -85 28 -25 25 -25 -45 9 -121 59 -374 187 -385 195 -28 22 -313
171 -361 189 -68 26 -86 26 -109 1 -74 -82 135 -385 427 -619 86 -68 278 -200
348 -237 19 -11 37 -22 40 -25 3 -3 40 -23 82 -44 42 -22 76 -41 74 -42 -6 -7
-497 158 -826 277 -152 55 -208 70 -261 70 -44 0 -48 -2 -58 -31 -25 -71 61
-221 214 -374 88 -89 130 -121 275 -214 19 -13 26 -20 15 -16 -11 3 -117 36
-235 71 -332 100 -340 101 -340 33 0 -107 152 -296 355 -440 110 -79 208 -136
298 -175 37 -15 67 -31 67 -35 0 -8 -151 13 -355 51 -278 52 -315 52 -315 2 0
-60 92 -176 204 -259 78 -58 227 -128 378 -178 l43 -15 -46 5 c-164 16 -255
17 -273 2 -19 -14 -19 -15 10 -60 15 -25 56 -71 90 -102 l61 -55 -32 -63 c-19
-34 -58 -109 -88 -167 -45 -85 -60 -106 -83 -113 -39 -11 -134 -1 -219 24 -38
11 -80 23 -92 26 -13 3 -23 8 -23 12 0 7 -42 26 -80 36 -14 3 -38 12 -55 20
-90 41 -126 55 -140 55 -9 0 -30 8 -48 17 -38 20 -277 33 -277 15 0 -5 -36
-13 -80 -17 l-80 -7 0 -124 c0 -123 0 -125 25 -136 14 -6 25 -15 25 -20 0 -4
6 -8 13 -8 12 0 50 -50 62 -80 6 -17 -75 -106 -106 -115 -18 -6 -19 -20 -19
-246 0 -131 4 -239 8 -239 21 0 33 -58 31 -149 -1 -61 2 -105 10 -120 17 -32
80 -91 96 -91 7 0 15 -3 17 -7 5 -12 58 -48 108 -73 25 -12 47 -26 50 -30 3
-4 22 -13 43 -19 20 -7 37 -16 37 -21 0 -4 10 -10 23 -13 43 -11 125 -43 150
-60 15 -9 32 -17 40 -17 7 0 23 -14 36 -31 26 -35 37 -98 46 -267 15 -309 41
-558 79 -767 31 -170 38 -203 63 -295 42 -162 151 -477 191 -557 6 -10 42 -85
82 -168 39 -82 75 -152 78 -155 4 -3 17 -25 29 -50 43 -87 170 -291 213 -343
6 -7 24 -30 40 -52 17 -22 37 -49 45 -60 16 -21 19 -35 8 -35 -12 0 -325 -47
-428 -64 -49 -8 -117 -18 -150 -22 -50 -5 -56 -8 -36 -15 30 -12 26 -14 -24
-23 -37 -7 -39 -6 -20 8 17 13 18 15 3 16 -26 0 -48 -11 -42 -22 4 -6 -4 -8
-23 -4 -27 6 -259 -26 -270 -38 -8 -8 132 7 149 16 10 4 29 6 42 2 14 -3 31
-2 38 2 7 5 40 9 73 9 33 1 85 5 115 9 30 5 52 6 49 2 -11 -12 -198 -33 -203
-22 -3 7 -8 7 -13 -2 -5 -7 -27 -13 -49 -14 -21 -1 -41 -4 -44 -8 -3 -3 -50
-14 -105 -24 -102 -18 -125 -28 -125 -52 0 -16 -27 -19 -32 -4 -2 6 -12 12
-23 15 -11 2 -31 7 -45 10 -20 5 -22 4 -8 -4 22 -15 263 -111 277 -111 6 0 11
-3 11 -8 0 -7 -98 -29 -225 -51 -40 -7 -40 -7 25 -16 l65 -9 -45 -7 c-106 -17
-126 -22 -136 -30 -6 -5 -14 -6 -18 -2 -3 4 -4 -7 0 -23 5 -28 2 -32 -65 -72
-40 -24 -81 -50 -92 -60 -11 -9 -29 -24 -40 -34 -35 -29 -39 -69 -15 -155 12
-43 27 -87 34 -98 25 -45 51 -156 62 -261 12 -122 6 -657 -10 -809 -5 -49 -12
-119 -15 -155 -6 -79 -17 -137 -53 -295 -16 -67 -27 -126 -24 -133 2 -7 20
-21 40 -31 35 -18 58 -19 353 -13 314 5 316 5 355 -17 45 -26 83 -95 110 -201
9 -36 21 -69 25 -74 5 -6 9 -22 9 -36 0 -16 11 -37 26 -51 l26 -24 4131 3
4131 3 51 24 c27 14 88 61 134 105 l85 80 107 0 106 0 17 58 c9 31 29 90 44
131 l27 74 45 4 c43 4 314 61 392 83 21 6 42 20 48 30 8 14 21 20 46 20 19 0
33 4 30 9 -3 5 -49 39 -101 76 -94 67 -111 82 -103 91 4 4 116 -11 263 -36 33
-5 62 -10 64 -10 3 0 -4 6 -15 14 -14 11 -16 18 -8 26 8 8 9 24 3 48 -5 20
-25 111 -45 202 -20 91 -42 190 -49 220 -35 152 -49 215 -71 320 -43 204 -46
225 -36 261 6 19 23 79 40 134 93 316 158 562 149 571 -5 6 -181 35 -344 57
-73 10 -103 11 -103 3 0 -6 14 -40 30 -75 17 -35 29 -65 27 -68 -4 -3 -35 23
-104 89 -28 28 -52 42 -75 44 -18 1 -69 7 -113 13 -44 5 -134 17 -200 26 -66
8 -126 18 -134 20 -7 3 -59 12 -114 20 -56 9 -103 18 -106 21 -5 5 39 1 199
-17 138 -15 144 -9 12 12 -175 27 -616 76 -887 99 -515 44 -1005 80 -1099 80
-65 0 -75 8 -39 31 25 17 45 18 215 12 139 -5 188 -3 188 5 0 7 8 12 18 12 15
1 15 2 1 10 -9 5 -87 15 -175 21 -87 7 -160 13 -162 15 -2 1 4 23 12 48 9 26
16 69 16 96 0 56 -30 146 -60 178 -28 30 -50 99 -50 160 0 81 -14 108 -118
219 -13 14 -26 22 -29 19 -4 -4 -1 -12 5 -18 17 -17 15 -28 -5 -28 -9 0 -25
-7 -35 -16 -16 -15 -22 -15 -55 -3 -45 18 -51 31 -22 60 17 17 29 20 63 16 37
-5 39 -4 22 9 -11 8 -28 14 -39 14 -18 0 -17 1 2 26 12 15 21 34 22 43 0 13 2
12 8 -3 7 -17 8 -17 23 5 8 13 18 34 22 47 4 13 11 22 15 20 107 -44 121 -53
121 -81 0 -16 10 -37 24 -50 18 -17 22 -29 19 -54 -4 -26 1 -38 25 -63 18 -18
41 -30 56 -30 29 0 31 -6 27 -100 -2 -47 2 -59 24 -83 14 -15 31 -27 38 -27 7
0 21 -15 31 -34 18 -34 42 -51 86 -59 14 -3 45 -13 70 -22 37 -14 54 -15 99
-6 50 10 121 45 121 59 0 4 -22 7 -49 8 -26 0 -65 9 -87 20 -36 18 -39 22 -36
57 3 33 -2 43 -37 79 -39 38 -52 68 -31 68 12 0 24 43 24 90 1 44 27 50 85 21
22 -12 51 -21 63 -21 16 0 32 -14 53 -47 40 -63 88 -95 137 -91 45 3 62 -15
71 -77 10 -59 -10 -110 -61 -157 l-44 -41 38 7 c118 23 194 118 194 243 0 73
-14 125 -44 160 -34 41 -41 94 -16 116 27 23 34 22 74 -13 48 -42 70 -104 64
-180 -5 -71 3 -73 47 -11 28 40 30 48 30 139 0 88 -3 101 -28 145 -16 26 -51
64 -78 83 -27 20 -49 39 -49 42 0 4 -15 8 -34 9 -28 2 -39 -3 -59 -28 -21 -27
-28 -30 -56 -24 -18 4 -35 14 -37 23 -3 10 -10 25 -15 35 -8 14 -6 24 6 37 15
16 14 19 -11 39 -15 11 -36 21 -47 21 -25 0 -107 -39 -104 -48 1 -4 -8 -20
-19 -34 -19 -24 -25 -26 -53 -18 -18 5 -39 6 -48 3 -13 -5 -15 0 -11 25 3 24
0 33 -18 42 -12 7 -30 10 -40 7 -16 -4 -15 -5 4 -6 12 0 22 -7 22 -15 0 -20
-25 -37 -43 -30 -11 4 -18 -1 -22 -18 -8 -33 -58 -52 -138 -53 -66 0 -68 1
-64 22 3 17 0 23 -14 23 -11 0 -19 7 -19 15 0 8 -9 15 -21 15 -15 0 -19 5 -15
18 5 15 -1 20 -31 28 -35 8 -38 12 -39 47 -1 27 4 41 17 47 11 7 20 7 24 0 3
-5 15 -15 26 -21 19 -10 20 -9 9 10 -8 16 -8 21 1 21 6 0 9 7 5 15 -3 8 0 15
7 15 7 0 -2 7 -19 16 -40 20 -100 82 -109 114 l-7 25 19 -22 c33 -37 33 -27 2
42 -33 73 -38 105 -14 85 20 -16 19 -5 -5 65 -24 70 -24 69 -4 61 19 -7 12 21
-17 72 -10 18 -19 40 -19 47 0 8 -11 22 -26 31 -14 9 -23 22 -20 29 2 7 -4 31
-15 55 -24 54 -18 61 15 17 17 -22 24 -41 20 -52 -5 -12 0 -23 17 -36 52 -40
47 -23 -42 165 -12 25 -19 49 -18 54 2 5 35 43 73 83 55 58 68 67 62 46 -8
-33 -2 -34 27 -4 19 18 34 38 85 107 2 2 7 -1 11 -8 10 -16 81 114 82 149 0
13 4 33 9 44 6 13 7 1 3 -35 -3 -30 -2 -52 2 -48 4 4 33 66 64 138 31 73 60
133 66 134 5 0 13 -15 18 -34 15 -60 24 -54 37 26 6 43 13 83 14 88 2 6 1 8
-1 4 -12 -21 -24 -4 -23 30 1 20 1 48 0 62 -1 23 -3 21 -14 -10 -26 -71 -65
-136 -102 -170 l-37 -34 15 29 c16 32 31 155 19 155 -4 0 -17 -17 -29 -39 -25
-43 -87 -101 -161 -149 -56 -35 -61 -34 -32 7 19 27 62 143 55 150 -2 2 -30
-25 -63 -60 -32 -36 -82 -77 -111 -93 -56 -30 -70 -31 -42 0 27 30 75 104 71
109 -3 2 -27 -13 -54 -34 -44 -34 -131 -75 -205 -96 -23 -7 -22 -4 11 31 57
61 139 174 126 174 -2 0 -17 -11 -32 -24 -46 -39 -114 -73 -194 -95 -41 -11
-76 -19 -78 -17 -2 2 25 31 59 65 l63 61 -58 -26 c-32 -14 -80 -32 -107 -39
l-48 -13 61 58 c34 32 59 62 55 66 -5 4 -16 0 -25 -8 -24 -22 -125 -62 -201
-82 -87 -22 -91 -21 -46 15 52 41 65 63 29 49 -48 -18 -50 -10 -4 19 63 40 94
71 114 111 18 35 18 35 -2 17 -20 -17 -133 -78 -133 -71 0 2 6 18 14 36 21 51
38 109 33 114 -2 3 -16 -10 -30 -28 -27 -35 -114 -128 -120 -128 -2 0 1 21 8
48 7 26 16 67 20 92 l7 45 -37 -37 c-31 -30 -88 -66 -140 -87 -5 -2 2 9 16 25
30 33 79 105 79 116 0 4 -21 -4 -47 -17 -27 -13 -73 -27 -103 -31 l-55 -6 45
30 c60 39 121 95 96 88 -10 -4 -53 -9 -95 -12 l-76 -5 40 23 c63 35 145 92
140 96 -2 2 -20 -2 -41 -8 -35 -12 -206 -41 -211 -36 -2 1 32 27 75 57 l77 54
-35 3 c-86 6 -89 12 -20 36 36 13 79 29 95 36 l30 13 -47 8 c-26 4 -71 15
-100 25 l-53 18 45 7 c25 4 83 22 130 40 l85 34 -55 6 c-53 6 -133 40 -175 74
-20 16 -19 16 5 8 38 -12 179 -8 192 5 9 9 7 12 -8 13 -10 0 -37 9 -59 19
l-40 19 32 0 c79 2 174 41 100 41 -27 0 -142 53 -152 71 -6 9 -3 10 11 4 27
-12 139 -18 171 -10 24 6 20 9 -42 30 -85 30 -97 41 -39 36 25 -1 61 0 82 4
l37 8 -50 11 c-27 7 -59 17 -70 24 -16 9 -7 10 46 5 49 -4 82 -1 125 12 55 17
105 44 59 32 -49 -13 -97 -18 -91 -9 3 5 26 17 51 26 25 10 45 23 45 31 0 7
26 25 58 41 31 16 71 37 87 47 l30 19 -39 -6 c-35 -5 -37 -4 -20 8 10 7 44 23
74 35 30 12 71 31 90 42 l35 20 -45 -7 c-56 -8 -45 4 32 37 59 25 76 40 36 33
-46 -9 65 38 135 56 l72 19 -55 1 -55 2 95 23 c52 13 115 28 140 33 l45 10
-45 1 c-73 2 -33 21 60 28 84 6 84 6 45 18 -58 16 -29 23 122 31 121 7 124 8
97 23 -25 13 -26 16 -10 19 16 4 139 -11 206 -24 24 -5 24 -5 6 10 -11 9 -17
18 -14 21 5 6 110 -19 129 -30 5 -4 30 -8 54 -10 25 -1 67 -14 95 -29 53 -28
100 -34 100 -13 0 7 25 25 56 40 102 50 278 173 346 241 101 102 161 199 221
361 35 94 46 140 50 205 3 49 9 63 48 111 58 70 109 156 159 263 138 294 163
684 65 1012 -47 154 -107 254 -153 254 -25 0 -58 -40 -73 -89 -6 -20 -13 -114
-16 -209 l-6 -174 -21 53 c-11 30 -25 52 -31 51 -6 -2 -9 -60 -7 -157 3 -148
-11 -365 -27 -408 -5 -13 -10 13 -14 74 -25 349 -181 764 -314 827 -29 14 -34
14 -56 -1 -38 -25 -51 -90 -43 -220 3 -62 11 -130 16 -152 5 -22 7 -41 5 -43
-1 -2 -13 15 -26 37 -12 22 -29 43 -37 46 -16 6 -13 -28 14 -168 9 -43 14 -81
12 -83 -3 -2 -27 28 -54 68 -64 95 -213 245 -293 297 -106 68 -171 52 -171
-44 0 -44 19 -119 44 -178 18 -42 11 -42 -31 -4 -17 15 -23 17 -23 6 0 -19 14
-65 34 -111 9 -21 14 -38 11 -38 -2 0 -37 30 -77 66 -201 181 -378 260 -424
189 -13 -19 -15 -37 -10 -75 4 -28 5 -50 2 -50 -2 0 -28 16 -58 35 -29 20
-119 69 -199 110 -351 178 -725 304 -1129 379 -663 123 -1377 73 -2041 -144
-149 -48 -433 -160 -450 -177 -5 -5 31 -48 79 -95 l87 -86 125 49 c283 112
519 178 825 229 240 41 358 50 646 50 598 0 1115 -116 1684 -377 104 -48 140
-60 181 -60 38 -1 70 -10 130 -39 43 -22 83 -41 87 -43 5 -2 6 6 3 17 -4 11
-3 23 2 26 12 7 112 -41 112 -54 0 -15 -7 -13 -48 15 -61 42 -68 29 -26 -49
l26 -49 -43 27 c-79 49 -203 105 -246 112 -36 6 -45 3 -69 -21 -23 -23 -26
-32 -21 -69 3 -23 9 -51 13 -61 4 -13 -3 -9 -22 12 -64 72 -504 244 -854 334
-347 89 -563 114 -975 113 -290 -1 -336 -3 -490 -27 -251 -38 -406 -72 -525
-117 -52 -19 -53 -20 -15 -14 22 3 75 14 119 25 111 27 138 22 36 -6 -47 -13
-107 -33 -133 -43 -44 -17 -47 -20 -33 -34 14 -15 26 -14 128 8 249 55 537 84
828 84 382 0 705 -43 1057 -140 233 -64 459 -146 688 -249 67 -30 83 -41 62
-41 -90 0 -105 -81 -36 -193 17 -27 29 -51 27 -52 -2 -2 -35 3 -73 11 -90 20
-252 16 -265 -6 -25 -39 -3 -95 63 -168 l42 -45 -30 6 c-16 4 -77 10 -135 13
-129 8 -160 -2 -160 -47 0 -33 54 -117 93 -144 11 -8 19 -16 16 -18 -2 -2 -42
0 -89 4 -143 14 -230 -6 -230 -52 0 -25 24 -63 68 -110 l33 -36 -133 -5 c-154
-5 -211 -23 -216 -68 -4 -31 35 -83 95 -130 24 -18 43 -35 43 -39 0 -4 -62
-14 -137 -24 -152 -19 -226 -46 -231 -83 -4 -25 55 -91 108 -123 l35 -21 -31
0 c-17 0 -34 -3 -37 -7 -4 -3 -48 -17 -98 -29 -142 -36 -165 -61 -114 -122 30
-36 31 -49 5 -57 -11 -3 -20 -12 -20 -20 0 -7 -11 -20 -25 -29 -23 -15 -25
-15 -41 9 -9 14 -28 31 -42 38 -14 6 -49 39 -77 72 -28 33 -56 60 -62 60 -7 0
-30 25 -52 55 -22 30 -47 62 -55 71 -9 8 -36 59 -61 112 -33 72 -45 109 -45
144 0 83 -73 280 -138 376 -31 45 -251 275 -270 281 -17 6 -99 125 -123 179
-7 15 -18 27 -25 27 -7 0 -29 24 -50 53 -76 104 -134 189 -134 197 0 5 -3 10
-7 12 -5 2 -33 41 -63 88 -84 131 -110 162 -133 158 -28 -4 -41 -56 -34 -143
6 -69 6 -70 -13 -47 -10 12 -22 22 -26 22 -7 0 1 -102 13 -169 l6 -34 -34 24
c-42 29 -308 289 -524 510 -196 200 -429 459 -580 644 -22 27 -56 67 -75 90
-20 22 -57 66 -83 97 -55 66 -104 100 -134 92 -108 -29 113 -509 366 -797 56
-64 61 -73 30 -57 -29 16 -493 480 -629 630 -171 188 -291 309 -332 336 -47
30 -84 31 -99 2z m895 -388 c-6 -5 -24 21 -24 34 0 6 6 1 14 -10 8 -10 12 -21
10 -24z m28 -24 c7 -8 42 -49 78 -92 204 -245 411 -473 655 -722 88 -90 162
-169 164 -175 15 -42 -358 331 -548 548 -62 72 -125 144 -140 160 -14 17 -42
50 -61 75 -19 25 -37 47 -40 50 -11 9 -130 161 -130 166 0 8 9 4 22 -10z m-98
-391 c23 -23 167 -150 206 -183 86 -72 265 -215 320 -257 36 -27 74 -58 85
-68 20 -19 20 -19 -6 -6 -42 23 -253 177 -336 246 -84 70 -170 151 -273 259
-56 59 -53 66 4 9z m6356 -225 c38 -198 34 -422 -10 -603 -39 -156 -137 -354
-245 -492 -25 -32 -45 -56 -45 -52 0 18 27 69 74 141 90 136 147 262 192 426
21 80 27 123 31 270 5 166 0 237 -32 425 -13 75 18 -25 35 -115z m-456 -95
c37 -125 61 -245 54 -267 -3 -7 -12 28 -22 77 -10 50 -33 141 -52 202 -37 122
-39 132 -25 118 5 -6 25 -64 45 -130z m-4111 58 c-7 -2 -19 -2 -25 0 -7 3 -2
5 12 5 14 0 19 -2 13 -5z m-68 -12 c-11 -5 -38 -11 -60 -14 l-40 -6 40 14 c22
7 49 14 60 14 l20 0 -20 -8z m-1860 -59 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5
10 -3 15 -9 12 -12z m91 -46 c126 -74 225 -138 220 -143 -4 -4 -74 34 -219
121 -45 26 -82 56 -70 56 6 0 37 -16 69 -34z m4664 -41 c0 -5 -5 -3 -10 5 -5
8 -10 20 -10 25 0 6 5 3 10 -5 5 -8 10 -19 10 -25z m-3114 -249 c49 -70 113
-162 142 -203 28 -42 52 -81 52 -87 -2 -48 -300 378 -300 429 0 13 8 2 106
-139z m-633 -17 c64 -31 101 -58 92 -67 -3 -3 -13 2 -23 12 -18 15 -135 66
-154 66 -5 0 -7 -4 -3 -9 4 -8 -51 14 -64 26 -2 1 17 3 43 3 33 0 66 -10 109
-31z m243 -40 c23 -11 48 -27 55 -35 11 -14 7 -14 -26 1 -22 9 -59 24 -82 32
-24 8 -43 17 -43 19 0 12 59 1 96 -17z m261 -255 l28 -26 -37 21 c-34 18 -38
19 -38 4 0 -13 -3 -14 -11 -6 -13 13 -4 33 16 33 8 0 27 -12 42 -26z m146 -14
c44 -41 30 -46 -18 -5 -22 19 -34 34 -27 35 7 0 27 -13 45 -30z m279 -111 c31
-46 79 -106 107 -134 55 -54 68 -51 21 4 -47 55 -24 51 28 -4 98 -105 155
-171 178 -206 36 -58 72 -151 83 -215 5 -33 12 -72 16 -89 5 -20 4 -27 -3 -20
-5 6 -19 47 -30 92 -22 85 -40 129 -49 119 -8 -7 -51 43 -59 68 -4 11 -31 44
-60 74 -30 30 -71 75 -92 101 -20 25 -45 53 -54 61 -26 24 -117 148 -138 190
-19 38 -28 78 -12 54 4 -6 33 -48 64 -95z m-1345 75 c-3 -3 -12 -4 -19 -1 -8
3 -5 6 6 6 11 1 17 -2 13 -5z m803 -104 c0 -14 -14 -12 -28 2 -19 19 -14 30 8
18 11 -6 20 -15 20 -20z m4525 -30 c61 -23 126 -138 124 -218 l-1 -37 -8 40
c-19 92 -109 213 -150 202 -13 -3 -17 0 -13 9 6 17 13 17 48 4z m-150 -55 c37
-36 30 -54 -7 -18 -18 17 -42 33 -53 36 -15 3 -13 5 8 6 17 1 37 -8 52 -24z
m-243 -26 c39 -21 80 -64 109 -114 16 -27 29 -54 28 -60 0 -5 -9 8 -21 30 -39
76 -119 142 -158 132 -13 -3 -17 0 -13 9 6 17 27 18 55 3z m632 -33 c17 -36
22 -96 7 -96 -4 0 -11 20 -14 45 -2 25 -13 55 -22 65 -15 17 -16 20 -3 20 9 0
23 -15 32 -34z m-4354 -1 c41 -26 52 -45 25 -45 -19 0 -95 69 -77 70 7 0 30
-11 52 -25z m-1337 8 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z
m4914 -29 l28 -26 -36 20 c-22 12 -42 17 -50 12 -16 -10 -32 -3 -24 11 11 18
54 9 82 -17z m-4562 -44 c35 -11 49 -19 35 -19 -31 0 -142 37 -115 38 11 0 47
-8 80 -19z m4340 10 c14 -6 5 -9 -35 -9 -40 0 -49 3 -35 9 11 5 27 9 35 9 8 0
24 -4 35 -9z m-3780 -70 c3 -5 -3 -10 -14 -10 -11 0 -23 5 -26 10 -3 6 3 10
14 10 11 0 23 -4 26 -10z m4556 -20 c22 -30 38 -107 20 -96 -6 4 -11 18 -11
30 0 13 -10 36 -21 51 -18 22 -27 26 -53 21 -29 -5 -30 -5 -11 10 27 20 54 14
76 -16z m-1004 -26 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m1211 -16 c28 -36 21 -159 -13 -198 -7 -8 -16 -26 -19 -40 -12 -43 -80 -193
-83 -183 -2 5 8 35 22 67 25 57 34 112 15 101 -5 -3 -10 1 -10 10 0 8 7 18 15
21 17 7 20 31 5 36 -18 6 4 83 23 82 13 -1 16 6 15 37 -1 35 -3 38 -17 26 -36
-31 -43 -30 -27 1 14 28 40 51 57 52 4 0 11 -6 17 -12z m-1339 -92 c-11 -9
-69 -15 -64 -6 3 6 20 10 37 10 17 0 29 -2 27 -4z m688 -61 c48 -20 38 -27
-15 -12 -24 7 -40 16 -36 20 10 9 9 9 51 -8z m213 -17 c50 -35 100 -118 71
-118 -6 0 -11 9 -11 19 0 23 -59 86 -89 96 -11 3 -21 11 -21 16 0 15 15 11 50
-13z m-470 -8 c0 -5 -12 -10 -26 -10 -14 0 -23 4 -19 10 3 6 15 10 26 10 10 0
19 -4 19 -10z m-2916 -52 c9 -12 19 -38 22 -58 7 -35 50 -122 100 -201 31 -50
24 -62 -14 -26 -16 15 -32 27 -37 27 -11 0 -55 41 -55 52 0 4 10 8 22 8 21 0
21 0 3 20 -11 12 -20 29 -21 38 -9 57 -18 90 -35 124 -21 41 -10 52 15 16z
m3651 -8 c8 -16 15 -51 15 -77 -1 -46 -1 -47 -14 -23 -7 14 -16 42 -20 63 -4
21 -14 41 -22 44 -21 8 -17 23 6 23 11 0 26 -12 35 -30z m-926 -14 c-2 -2 -22
-6 -44 -9 -27 -4 -35 -3 -25 3 14 9 79 15 69 6z m910 -140 c0 -20 -1 -21 -9
-1 -9 19 -9 19 -16 -2 -7 -25 -19 -29 -29 -13 -12 19 3 38 29 38 20 0 26 -5
25 -22z m-229 -51 c14 -41 7 -72 -7 -35 -6 14 -13 38 -17 53 -10 40 10 25 24
-18z m128 33 c13 -13 17 -48 5 -48 -3 0 -15 7 -25 17 -17 15 -18 15 -18 0 0
-10 -7 -17 -15 -17 -18 0 -19 14 -5 41 12 21 40 25 58 7z m-1515 -15 c-7 -2
-19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-68 -18 c-34 -13 -87 -23 -79
-16 5 5 18 11 29 14 23 6 65 7 50 2z m452 -1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6
6 6 11 1 17 -2 13 -5z m905 -56 c20 -30 31 -68 21 -68 -19 1 -32 18 -38 53 -8
42 -4 47 17 15z m-3188 -42 c63 -52 128 -117 122 -123 -3 -3 -28 0 -56 7 -39
9 -54 18 -60 36 -5 13 -14 24 -20 24 -5 0 -17 17 -27 38 -9 20 -19 40 -21 45
-10 18 25 4 62 -27z m1737 8 c-35 -8 -66 -12 -69 -10 -5 6 76 24 108 24 14 0
-4 -6 -39 -14z m434 -4 c-27 -12 -43 -12 -25 0 8 5 22 9 30 9 10 0 8 -3 -5 -9z
m-517 -15 c-3 -3 -20 -10 -38 -15 -19 -5 -29 -6 -24 -1 12 12 74 27 62 16z
m1465 -76 c-28 -12 -31 -10 -38 12 -11 33 16 44 38 17 18 -21 18 -22 0 -29z
m-1042 10 c-24 -5 -54 -15 -67 -24 -13 -8 -25 -11 -28 -6 -8 13 63 40 104 39
34 0 34 0 -9 -9z m979 -68 c-1 -10 -6 -7 -15 9 -19 33 -18 50 0 26 8 -11 15
-27 15 -35z m-80 -10 c-1 -13 -3 -13 -15 3 -19 26 -19 42 0 26 8 -7 15 -20 15
-29z m-2847 -2 c65 -22 97 -43 97 -66 0 -15 -65 -18 -75 -3 -3 6 -14 10 -24
10 -10 0 -30 15 -45 34 -41 54 -40 54 47 25z m1322 11 c-11 -5 -27 -9 -35 -9
-9 0 -8 4 5 9 11 5 27 9 35 9 9 0 8 -4 -5 -9z m490 -29 c-3 -5 -21 -15 -41
-21 -20 -7 -48 -18 -62 -26 -33 -17 -61 -19 -45 -3 12 12 123 58 141 59 7 0
11 -4 7 -9z m-530 -20 c-6 -5 -21 -12 -35 -15 l-25 -7 25 15 c28 17 50 21 35
7z m-1190 -71 c26 -11 51 -17 57 -14 12 8 67 -55 68 -77 0 -9 -7 -22 -15 -29
-12 -10 -21 -8 -47 12 -18 14 -45 28 -60 32 -18 4 -30 15 -34 31 -3 14 -19 30
-35 37 -16 7 -29 16 -29 20 0 14 48 8 95 -12z m990 -50 c-27 -12 -43 -12 -25
0 8 5 22 9 30 9 10 0 8 -3 -5 -9z m205 -44 c0 -2 -9 -6 -20 -9 -11 -3 -18 -1
-14 4 5 9 34 13 34 5z m-979 -69 c16 -39 1 -63 -37 -60 -42 3 -61 12 -46 22 9
5 5 11 -13 21 -26 14 -34 39 -12 41 6 1 25 0 41 -1 23 -1 28 2 23 14 -12 30
31 -6 44 -37z m83 -50 c31 -40 33 -77 7 -101 -18 -17 -20 -16 -40 1 -12 9 -21
23 -21 30 0 7 -11 13 -25 13 -36 0 -31 24 10 43 24 11 33 21 29 32 -11 27 14
16 40 -18z m-4297 -39 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m4734 -14 c-19 -8 -36 -12 -39 -9 -6 6 37 24 58 24 8 0 0 -6 -19 -15z m-332
-50 c6 -14 11 -36 11 -49 0 -26 7 -29 34 -19 9 3 12 12 9 22 -12 36 36 -23 66
-81 27 -51 31 -55 41 -38 5 11 7 28 4 38 -5 15 -3 15 8 -2 7 -11 20 -20 28
-20 8 0 22 -16 32 -36 9 -19 23 -41 32 -48 14 -12 16 -10 16 13 0 23 2 25 19
14 10 -6 36 -37 56 -67 20 -31 35 -46 32 -34 -9 42 11 34 42 -17 17 -28 31
-63 31 -77 0 -27 -1 -27 -27 12 -15 21 -28 34 -30 28 -6 -18 -40 -3 -52 23 -6
13 -17 24 -25 24 -9 0 -20 9 -26 20 -13 24 -30 18 -30 -11 0 -10 -7 -19 -15
-19 -11 0 -15 11 -15 37 0 29 -3 34 -12 25 -19 -19 -27 -14 -34 23 -3 19 -10
35 -16 35 -5 0 -7 -4 -4 -9 3 -5 -1 -14 -9 -21 -12 -10 -16 -9 -21 5 -5 13 -9
14 -15 3 -6 -9 -9 -3 -9 18 0 16 -6 38 -13 48 -12 16 -14 16 -27 -11 -11 -22
-14 -24 -17 -10 -3 9 -11 17 -19 17 -19 0 -18 17 4 29 18 11 16 12 -38 14 -32
2 -35 4 -32 29 2 20 -1 26 -11 22 -8 -3 -19 2 -26 10 -7 8 -19 12 -28 9 -11
-4 -14 0 -11 18 2 16 12 25 35 31 23 6 31 13 27 23 -10 26 22 6 35 -21z
m-4200 -24 c39 -17 109 -41 155 -53 l84 -22 -129 0 c-144 0 -163 -7 -135 -50
40 -61 218 -175 326 -209 30 -10 69 -24 87 -32 17 -8 40 -14 51 -14 36 0 32
-16 -4 -17 -19 -1 -34 3 -34 8 0 5 -8 9 -17 9 -15 0 -16 -2 -3 -10 31 -19 -3
-22 -113 -8 -100 13 -126 21 -215 64 -56 27 -102 54 -102 60 0 7 -9 14 -20 17
-16 4 -20 13 -20 44 0 36 39 175 53 190 11 11 8 23 -7 23 -7 0 -19 7 -26 15
-17 20 -13 19 69 -15z m4416 20 c-3 -5 -16 -10 -28 -10 -18 0 -19 2 -7 10 20
13 43 13 35 0z m311 -398 c-9 -9 -46 30 -46 47 1 11 8 8 26 -13 14 -15 23 -31
20 -34z m-150 1 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2 -18z
m-4028 -30 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z m-1077
-1048 c1 -71 4 -121 6 -111 4 15 7 16 14 5 6 -11 11 -11 21 -1 6 6 25 12 40
12 l28 0 1 73 c0 39 4 95 9 122 6 41 8 30 9 -65 1 -63 7 -160 12 -215 6 -55
11 -114 12 -132 4 -61 15 -18 19 69 1 47 6 90 10 94 4 3 19 -1 32 -10 14 -9
36 -16 49 -16 14 0 30 -7 37 -15 7 -8 23 -15 37 -15 15 0 39 -16 66 -43 46
-47 106 -87 130 -87 8 0 17 -5 19 -10 2 -6 35 -13 73 -17 112 -10 160 -41 171
-109 3 -24 10 -47 15 -50 5 -3 9 -13 10 -22 0 -9 14 -28 32 -42 30 -24 37 -25
172 -26 147 0 185 -6 185 -29 0 -7 4 -15 9 -17 6 -1 15 -25 22 -53 26 -112 52
-128 204 -130 59 0 115 -6 136 -14 31 -12 39 -22 62 -85 38 -100 61 -114 224
-136 92 -12 153 -38 153 -65 0 -11 9 -26 20 -33 11 -7 20 -21 20 -31 0 -11 9
-21 23 -25 42 -11 402 -6 577 9 210 18 192 17 186 6 -3 -5 5 -12 19 -15 17 -4
23 -11 18 -23 -6 -14 4 -15 101 -11 60 3 122 2 139 -3 21 -6 40 -4 61 6 17 7
57 25 90 40 32 14 56 28 54 31 -3 2 -56 0 -118 -6 -112 -9 -160 -6 -160 11 0
5 24 15 53 24 56 16 123 53 113 62 -3 3 -16 -1 -28 -9 -13 -8 -40 -18 -61 -22
-20 -4 -68 -20 -106 -36 -39 -17 -76 -30 -83 -29 -7 0 0 6 16 13 16 8 24 15
17 17 -7 3 27 14 75 26 55 14 105 34 135 55 49 33 61 55 14 24 -15 -10 -31
-16 -37 -14 -6 2 22 21 62 41 71 37 107 43 61 10 -18 -12 -20 -17 -10 -24 17
-11 69 -12 69 -1 0 4 13 13 28 20 24 10 41 9 108 -9 89 -23 92 -25 76 -41 -20
-20 -15 -58 8 -58 23 0 44 -43 36 -73 -5 -20 26 -121 35 -112 3 3 9 -29 13
-72 4 -47 12 -83 22 -94 13 -14 14 -26 6 -70 -6 -29 -15 -55 -21 -57 -6 -2
-11 -9 -11 -15 -1 -7 -19 -25 -41 -42 -22 -16 -46 -36 -54 -43 -29 -26 -149
-75 -228 -93 -121 -27 -127 -25 -58 26 34 25 59 50 56 55 -3 5 0 13 7 19 57
46 82 70 76 77 -4 3 -18 0 -31 -8 -46 -31 -187 -58 -296 -57 -177 2 -177 5
-11 87 80 39 156 81 170 92 l25 21 -25 -6 c-33 -9 -17 7 35 34 47 25 33 26
-72 6 -82 -16 -172 -19 -237 -8 l-38 6 92 33 c104 37 139 60 78 51 -21 -3 -38
-4 -38 -1 0 2 25 16 55 30 30 15 55 30 55 35 0 12 -2 12 -38 -7 -63 -31 -345
-104 -512 -133 -346 -59 -809 -70 -900 -21 -10 6 -31 10 -45 10 -23 0 -75 24
-179 84 -25 14 -65 47 -84 68 -9 9 -20 14 -25 11 -6 -3 -7 -1 -4 4 4 6 -8 22
-26 36 -17 14 -46 38 -64 54 -18 16 -52 44 -78 62 l-45 32 0 -26 c0 -63 95
-193 188 -257 23 -16 75 -46 115 -65 66 -33 70 -37 47 -44 -14 -4 -41 -7 -60
-8 -27 -1 -32 -3 -21 -13 9 -10 84 -13 309 -13 283 1 488 11 779 39 192 19
228 7 168 -54 -43 -45 -62 -60 -75 -60 -5 0 -10 -4 -10 -10 0 -5 -11 -10 -24
-10 -13 0 -26 -4 -28 -8 -9 -23 -490 -149 -773 -203 -95 -18 -156 -23 -290
-24 l-170 0 -90 39 c-49 22 -99 48 -109 58 -11 10 -23 18 -26 18 -7 0 -14 6
-98 82 -22 21 -44 33 -47 28 -9 -14 32 -100 63 -134 15 -16 44 -41 64 -56 l38
-27 -51 -7 c-27 -4 -60 -11 -72 -15 -12 -5 -75 -26 -140 -47 l-119 -39 -44 50
-44 50 16 -39 c50 -126 -72 57 -184 274 -41 80 -78 149 -83 154 -5 6 -9 16 -9
22 0 7 -5 25 -11 41 -10 26 -12 27 -19 8 -8 -17 -9 -16 -9 8 -1 15 -8 39 -17
52 -9 14 -14 34 -11 45 3 11 1 17 -4 14 -15 -9 -39 23 -40 53 0 24 -2 25 -8 8
-7 -16 -11 -8 -21 38 -7 31 -17 57 -22 57 -4 0 -8 9 -8 20 0 11 -9 43 -20 72
-11 29 -20 62 -20 73 0 23 -16 9 -22 -20 -3 -14 -7 -8 -13 20 -4 22 -14 49
-22 60 -15 19 -15 19 -10 -5 16 -76 80 -312 103 -378 63 -182 114 -302 229
-537 89 -181 112 -235 102 -235 -6 0 -65 88 -95 140 -11 19 -36 64 -56 99 -38
67 -154 316 -181 392 -162 443 -230 780 -250 1234 -7 138 7 373 22 398 12 20
22 -57 24 -198z m-74 -372 c-2 -16 -4 -3 -4 27 0 30 2 43 4 28 2 -16 2 -40 0
-55z m21 -173 c-1 -28 -2 -25 -8 15 -5 28 -8 68 -8 90 1 35 2 33 8 -15 5 -30
8 -71 8 -90z m6504 88 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7
-17z m-6466 -303 c14 -71 39 -183 56 -248 16 -65 28 -121 25 -123 -12 -13
-103 387 -111 489 -3 34 -3 51 0 37 3 -14 16 -83 30 -155z m4959 115 c17 -34
18 -40 6 -40 -5 0 -11 8 -14 18 -2 9 -8 25 -12 35 -12 28 3 19 20 -13z m140
-50 c31 -19 83 -88 118 -157 26 -50 20 -50 -28 1 -25 27 -45 53 -45 59 0 6 7
2 15 -9 14 -19 14 -18 9 2 -5 19 -94 116 -94 102 0 -3 7 -22 15 -41 17 -41 20
-107 5 -107 -5 0 -10 24 -10 53 -1 28 -7 63 -15 77 -26 46 -19 50 30 20z
m1148 -50 c17 -20 22 -40 11 -40 -8 0 -43 43 -44 53 0 13 15 7 33 -13z m-992
-265 l27 -77 -39 38 c-40 39 -50 60 -24 50 20 -7 20 -5 -15 67 l-30 62 26 -31
c15 -18 40 -66 55 -109z m-121 25 c0 -44 -16 -94 -28 -86 -4 2 -3 34 2 70 11
70 26 79 26 16z m1173 -58 c9 -26 18 -64 22 -85 6 -37 5 -38 -15 -27 -16 8
-20 18 -16 34 3 12 -1 46 -9 76 -18 66 -17 63 -6 55 5 -3 16 -27 24 -53z
m-1308 -12 c-4 -23 -9 -39 -12 -36 -3 2 -2 23 2 46 4 23 9 39 12 36 3 -2 2
-23 -2 -46z m174 -144 c1 -63 -17 -139 -30 -130 -13 7 -11 114 1 114 6 0 10
26 11 58 1 77 17 40 18 -42z m1007 58 c-5 -18 -10 -24 -17 -17 -7 7 -7 17 2
31 17 27 23 20 15 -14z m-866 -60 c11 -30 20 -60 20 -66 0 -16 -44 42 -46 61
-1 9 -7 31 -13 49 -17 57 15 19 39 -44z m-5191 -54 c0 -23 -26 42 -33 81 -4
26 -2 23 13 -16 11 -27 20 -57 20 -65z m6221 -40 c-7 -4 -9 -18 -4 -36 l7 -29
-37 34 c-33 32 -44 58 -12 32 15 -13 16 4 2 84 -7 40 -6 40 24 -19 22 -41 28
-61 20 -66z m-135 -25 c-3 -26 -9 -45 -12 -42 -2 3 -1 26 2 52 4 25 10 44 12
41 3 -3 2 -26 -2 -51z m-6051 -29 c15 -38 25 -71 22 -73 -3 -4 -56 131 -56
144 0 14 10 -6 34 -71z m4843 42 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m319 -41 c10 -28 17 -64 16 -78 -1 -15 5 -43 13 -62 22 -52 19 -56
-14 -17 -45 52 -57 86 -41 115 10 18 10 31 1 56 -13 39 -14 52 -2 44 5 -3 17
-29 27 -58z m-90 -53 c16 -37 12 -108 -7 -120 -5 -3 -9 -2 -9 3 -3 46 -4 153
-2 153 2 0 10 -16 18 -36z m1149 -6 c50 -36 56 -43 39 -49 -27 -11 -42 -10
-24 1 12 7 9 11 -15 16 -16 4 -43 22 -58 40 -40 47 -14 44 58 -8z m-1274 -85
c-9 -15 -10 -12 -11 18 0 20 3 39 8 43 11 12 14 -42 3 -61z m-4897 7 c5 -17 4
-20 -2 -10 -5 8 -13 26 -16 40 -5 17 -4 20 2 10 5 -8 13 -26 16 -40z m5202
-144 c34 -36 55 -66 48 -66 -24 0 -59 18 -86 43 -15 14 -36 31 -46 39 -10 7
-22 30 -26 52 l-7 38 28 -20 c15 -11 56 -50 89 -86z m1700 19 c4 -9 -5 -27
-21 -43 -19 -18 -29 -23 -32 -14 -6 15 -33 16 -33 0 0 -17 -16 2 -24 28 -5 15
0 24 16 32 35 16 88 15 94 -3z m-1857 -58 c1 -16 -3 -26 -9 -22 -5 3 -10 25
-9 48 0 33 2 38 9 22 5 -11 9 -33 9 -48z m231 22 c0 -17 -4 -28 -10 -24 -5 3
-10 17 -10 31 0 13 5 24 10 24 6 0 10 -14 10 -31z m-5200 -14 c0 -5 -5 -3 -10
5 -5 8 -10 20 -10 25 0 6 5 3 10 -5 5 -8 10 -19 10 -25z m3457 3 c14 -24 8
-43 -21 -68 -16 -14 -37 -33 -48 -43 -10 -10 -24 -15 -31 -11 -7 4 -9 3 -4 -1
8 -9 -118 -68 -134 -63 -5 2 12 20 38 40 26 20 75 64 108 97 61 62 78 71 92
49z m-1094 -25 c-9 -3 -10 -10 -3 -24 14 -25 -11 -80 -54 -115 -29 -25 -179
-104 -221 -116 -11 -4 -76 -31 -145 -61 -582 -255 -753 -313 -902 -305 -94 5
-142 23 -243 90 -72 48 -79 65 -40 104 61 61 164 93 705 220 30 7 233 57 450
113 217 55 411 100 430 100 19 0 29 -3 23 -6z m4196 -37 c49 -14 63 -32 34
-43 -10 -3 -25 -12 -34 -20 -14 -12 -23 -11 -60 5 -59 25 -77 47 -52 61 24 14
59 13 112 -3z m527 -31 c41 -31 71 -73 80 -111 5 -23 -1 -18 -30 26 -21 30
-54 67 -73 83 -20 15 -30 27 -23 27 7 0 28 -11 46 -25z m-1837 -7 c5 -13 7
-25 5 -27 -7 -7 -34 21 -34 35 0 22 20 16 29 -8z m-2 -55 c23 -18 46 -33 51
-33 6 0 23 -11 39 -24 15 -13 57 -32 93 -41 36 -10 69 -22 75 -26 16 -15 35
-10 35 9 0 9 9 28 20 42 l19 25 9 -25 c8 -22 6 -27 -17 -36 -23 -10 -21 -11
26 -10 55 1 90 -17 64 -33 -7 -5 -22 -6 -32 -4 -14 4 -19 0 -19 -15 0 -11 -8
-22 -20 -25 -37 -10 -20 -22 72 -52 50 -17 93 -35 95 -40 1 -6 -18 -19 -43
-29 -43 -18 -47 -18 -56 -3 -5 10 -15 17 -22 17 -7 0 -30 15 -52 34 -28 24
-44 31 -59 26 -11 -4 -32 -4 -46 0 -34 10 -42 4 -60 -45 -16 -43 -46 -58 -55
-28 -3 10 -11 30 -19 45 -13 25 -12 29 11 47 23 18 23 19 4 24 -12 3 -20 14
-20 27 0 20 -3 22 -36 15 -33 -6 -36 -5 -31 14 6 23 -13 34 -58 35 -26 1 -30
4 -27 24 3 20 0 23 -18 17 -16 -5 -23 -2 -27 14 -3 12 -12 21 -19 21 -8 0 -14
9 -14 20 0 12 -7 20 -16 20 -14 0 -14 3 -4 15 7 8 21 15 32 15 10 0 21 7 24
15 7 17 29 5 101 -52z m123 -26 c0 -14 -5 -17 -22 -12 -37 11 -41 21 -22 56
l17 34 13 -30 c7 -16 13 -38 14 -48z m1349 62 c28 -6 53 -14 56 -19 3 -5 -10
-16 -30 -26 -19 -9 -35 -20 -35 -24 0 -10 -38 -20 -42 -11 -2 3 -16 13 -33 21
-33 17 -45 48 -23 61 18 12 47 11 107 -2z m-1263 -127 c-9 -8 -56 16 -56 28 0
6 7 22 17 36 l16 25 14 -41 c8 -23 12 -44 9 -48z m1406 39 c44 -28 88 -68 88
-81 0 -3 -16 -4 -35 -2 -21 3 -45 -2 -59 -11 -23 -15 -66 -13 -66 3 0 4 -11
18 -25 31 -42 40 -28 89 25 89 14 0 47 -13 72 -29z m-1028 -35 c-3 -9 -10 -13
-16 -10 -5 3 -4 12 3 20 15 18 22 13 13 -10z m-3529 5 c-3 -5 -1 -12 5 -16 6
-4 8 -11 5 -16 -4 -5 -2 -9 3 -9 5 0 16 -23 26 -52 l16 -51 -25 -27 c-14 -14
-72 -55 -130 -90 -58 -34 -105 -65 -105 -67 0 -2 49 22 110 52 60 30 117 55
126 55 8 0 35 -13 59 -30 24 -16 51 -30 59 -30 9 0 16 -6 16 -14 0 -8 8 -16
17 -18 14 -3 9 -12 -25 -50 l-43 -47 68 35 c87 44 93 43 86 -3 -5 -31 -4 -35
11 -30 10 4 23 -1 33 -13 10 -11 21 -20 25 -20 5 0 17 -9 28 -20 11 -11 31
-20 45 -20 25 0 25 0 8 -27 -9 -16 -49 -64 -87 -108 -68 -76 -73 -89 -13 -35
76 67 102 78 186 76 65 -1 84 -5 98 -20 17 -18 17 -19 0 -13 -11 4 -16 3 -11
-4 8 -14 -121 -140 -188 -183 -29 -18 -75 -43 -103 -55 -94 -39 -255 -66 -255
-42 0 5 19 26 43 46 l42 36 -55 -32 c-142 -83 -230 -110 -364 -110 -49 -1 -94
-7 -114 -15 -81 -37 -280 -57 -288 -29 -2 6 21 28 51 49 30 22 54 41 52 43 -2
1 -32 -13 -68 -31 -35 -19 -100 -46 -144 -62 -70 -24 -95 -28 -197 -29 -156 0
-162 6 -77 88 80 78 277 224 463 342 17 11 74 49 126 85 52 36 102 68 110 72
10 4 11 7 2 7 -14 1 -22 -3 -177 -104 -208 -135 -260 -166 -341 -205 -147 -72
-251 -86 -364 -51 -77 24 -130 59 -130 86 0 31 60 89 158 153 92 60 624 331
777 396 50 21 122 52 160 68 99 42 257 98 278 98 10 0 16 -4 12 -9z m3392 -23
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m108 -19 c16 -25 -70
-72 -86 -47 -4 6 -14 6 -28 -1 -11 -7 -21 -8 -21 -4 1 41 115 85 135 52z
m1157 -66 c23 -26 48 -79 48 -100 0 -10 -14 7 -31 37 -16 30 -34 57 -39 58
-12 4 -13 22 -2 22 5 0 16 -8 24 -17z m-936 -55 l19 -23 -25 20 c-14 11 -27
21 -29 22 -2 2 0 3 6 3 5 0 18 -10 29 -22z m-932 -21 c7 -7 16 -30 20 -52 4
-21 18 -52 31 -67 15 -18 22 -35 18 -46 -10 -27 -35 -52 -53 -52 -22 0 -59
-35 -71 -68 -12 -30 -3 -118 17 -183 14 -43 56 -94 99 -117 15 -9 -33 -12
-195 -12 -162 -1 -209 -4 -192 -12 12 -6 22 -15 22 -20 0 -12 -1277 -10 -1285
2 -4 6 8 11 27 11 l33 2 -35 6 c-75 14 15 20 433 27 235 4 427 10 427 14 0 4
-6 13 -13 19 -8 6 -20 37 -27 68 -7 32 -17 61 -22 64 -5 3 -13 30 -18 60 -5
30 -13 72 -18 94 -6 22 -12 74 -13 115 -2 41 -6 77 -10 80 -4 3 -1 16 6 30 13
23 14 20 16 -45 1 -38 3 -79 4 -90 1 -11 3 -28 4 -37 0 -10 5 -18 10 -18 23 0
137 88 165 127 l31 44 8 -31 c5 -19 16 -34 28 -37 20 -6 49 -83 49 -134 0 -15
4 -30 9 -33 11 -7 89 44 125 83 17 17 36 31 43 31 7 0 27 14 45 30 17 17 33
28 35 26 3 -2 -5 -22 -16 -45 -12 -22 -21 -43 -21 -46 0 -16 90 44 133 88 45
46 50 49 43 24 -15 -61 39 -10 71 68 20 50 20 50 37 32z m762 -53 c74 -25 81
-34 41 -53 -19 -9 -41 -22 -51 -30 -9 -8 -16 -9 -16 -3 0 6 -10 14 -22 17 -43
13 -78 30 -78 39 0 14 41 46 60 46 9 0 39 -7 66 -16z m175 -61 c9 -18 23 -43
33 -57 l16 -26 -31 0 c-17 0 -42 -9 -56 -20 -24 -19 -28 -19 -47 -5 -12 9 -29
18 -38 22 -12 3 -18 16 -18 38 0 37 15 45 85 45 30 0 36 3 27 12 -16 16 -15
31 1 26 6 -2 19 -18 28 -35z m98 -168 c17 -20 31 -46 31 -58 0 -21 -1 -21 -18
5 -9 14 -27 40 -40 57 -32 43 -11 39 27 -4z m-767 -89 c-7 -18 -8 -34 -3 -39
5 -5 7 -23 4 -41 -7 -45 11 -83 49 -102 18 -9 36 -22 40 -28 19 -28 6 -32 -84
-28 -86 4 -94 7 -126 36 -40 36 -58 68 -66 116 -6 32 -4 36 26 50 23 11 34 23
36 42 2 17 11 28 25 32 13 3 36 19 52 36 l29 30 15 -36 c11 -29 12 -43 3 -68z
m322 89 c22 -17 82 -20 91 -5 11 17 23 11 44 -24 12 -19 35 -39 53 -45 18 -6
45 -23 60 -38 23 -22 36 -26 78 -25 46 1 51 -2 65 -28 8 -16 15 -54 15 -85 l0
-56 -197 7 c-202 7 -237 13 -227 39 10 26 -4 61 -41 101 -19 21 -35 43 -35 48
0 6 -3 20 -6 32 -4 15 1 23 20 32 15 6 31 23 38 37 13 29 16 30 42 10z m-171
-97 c45 -24 47 -34 10 -48 -34 -12 -37 -11 -54 11 -17 22 -17 25 -2 37 20 15
19 15 46 0z m62 -103 c0 -24 -24 -29 -49 -10 -24 18 -11 37 22 33 19 -2 27 -9
27 -23z m485 -162 c0 -5 -7 -16 -14 -26 -13 -17 -23 -18 -128 -8 -62 6 -117
11 -122 11 -6 0 -1 7 10 15 14 11 49 14 137 15 64 0 117 -3 117 -7z m-6910
-159 c0 -2 -9 -4 -20 -4 -11 0 -20 4 -20 9 0 5 9 7 20 4 11 -3 20 -7 20 -9z
m1157 10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-177 -20
c-19 -8 -43 -13 -52 -10 -10 2 -18 -1 -18 -6 0 -7 26 -8 77 -4 124 11 81 0
-92 -24 -346 -48 -457 -68 -479 -87 -11 -11 -54 -48 -95 -84 l-74 -64 25 45
c14 25 34 60 44 77 16 27 17 36 6 53 -10 17 -10 21 0 24 17 5 202 34 258 41
25 3 110 14 190 25 133 18 191 25 230 28 8 1 -1 -6 -20 -14z m2956 -134 l-46
-49 0 -485 c0 -308 4 -486 10 -488 5 -1 72 -1 149 2 l139 5 53 45 c30 24 56
48 57 52 2 5 8 8 14 8 10 0 7 -42 -13 -190 -15 -107 -19 -119 -35 -113 -8 3
-12 8 -10 12 10 16 15 161 6 161 -6 0 -10 6 -10 14 0 11 -11 9 -47 -9 -44 -22
-59 -23 -198 -22 l-150 2 -5 135 c-4 90 -7 115 -10 75 -3 -58 -4 -58 -7 -15
-5 51 -23 80 -23 36 0 -25 -1 -26 -16 -11 -28 28 -63 47 -73 41 -11 -7 -81 24
-81 36 0 4 -4 8 -10 8 -5 0 -10 -12 -10 -27 0 -52 -11 -14 -18 63 -6 63 -9 27
-14 -183 l-7 -262 -28 -36 c-15 -19 -31 -35 -35 -35 -16 0 -7 20 22 53 l30 35
0 539 c0 584 3 550 -53 606 -10 10 -16 21 -14 24 3 2 106 8 229 12 122 4 229
9 237 9 7 1 -7 -20 -33 -48z m1314 -101 l0 -152 -44 41 c-75 69 -86 72 -266
72 l-160 0 1 -87 c1 -49 4 -121 8 -162 l6 -73 125 1 c114 2 128 4 162 26 21
14 40 25 43 25 3 0 5 -65 5 -145 0 -80 -3 -145 -7 -145 -4 0 -20 12 -36 28
-28 26 -31 27 -170 30 l-142 4 5 -184 5 -183 172 -3 171 -2 67 50 c37 28 69
49 72 47 2 -3 -1 -42 -7 -88 -5 -46 -10 -105 -10 -130 0 -55 -7 -79 -24 -79
-9 0 -12 23 -11 80 0 43 -2 75 -5 71 -7 -13 -61 -8 -56 4 2 6 -69 10 -203 10
l-206 0 -6 70 c-4 50 -6 58 -7 27 -2 -55 -22 -46 -23 11 -1 36 -2 38 -8 14
l-6 -28 -37 31 c-21 17 -45 33 -55 35 -10 2 -31 8 -47 14 -22 9 -31 9 -37 0
-4 -6 -11 26 -16 72 -9 78 -10 69 -12 -114 -1 -160 -4 -206 -17 -233 -9 -19
-20 -34 -25 -34 -22 0 -6 -19 19 -23 15 -2 6 -4 -20 -4 l-48 0 35 47 34 47 1
531 c1 518 1 533 -19 560 -11 16 -27 35 -36 42 -8 7 -15 16 -15 21 0 5 188 9
425 9 l425 0 0 -151z m915 137 c219 -11 269 -17 315 -35 75 -28 135 -85 163
-152 21 -52 22 -70 25 -426 4 -475 -4 -522 -100 -588 -59 -41 -147 -60 -273
-60 -249 0 -435 7 -441 17 -4 7 64 7 207 1 118 -4 247 -7 288 -6 70 2 171 28
171 44 0 4 9 10 19 14 11 3 22 13 26 22 5 14 3 14 -15 -2 -13 -12 -35 -18 -65
-18 -29 0 -42 -4 -38 -11 5 -8 2 -8 -8 0 -8 6 -45 12 -84 13 -38 2 -72 6 -75
10 -8 11 -80 13 -80 2 0 -10 -55 0 -85 16 -11 6 -31 13 -45 14 -14 2 -34 12
-44 22 -11 9 -30 17 -43 17 -13 0 -23 6 -23 14 0 8 -11 17 -25 20 -55 14 -65
36 -66 154 -1 59 -5 121 -9 137 -4 17 -8 -63 -8 -179 -2 -208 -2 -209 -27
-242 l-26 -34 23 -1 c16 -1 13 -3 -12 -9 -48 -11 -56 -3 -27 29 61 66 57 28
57 596 l0 520 -25 38 c-14 20 -29 37 -33 37 -4 0 -13 9 -20 20 -12 19 -10 20
65 19 43 0 195 -6 338 -13z m-2787 -158 l-3 -161 -115 -39 c-63 -21 -118 -38
-122 -38 -4 0 -8 23 -8 50 0 55 -18 107 -43 128 -22 18 -148 20 -181 3 -45
-25 -47 -43 -44 -453 3 -364 4 -387 22 -407 42 -46 140 -46 182 0 17 19 19 40
22 198 1 97 -1 171 -5 165 -9 -12 -93 -26 -93 -16 0 4 -3 42 -5 85 -3 42 -4
77 -3 78 7 2 453 26 456 24 1 -1 -9 -19 -24 -40 l-26 -39 4 -333 c2 -219 0
-332 -7 -330 -16 6 -23 82 -24 254 -1 96 -5 164 -11 168 -5 3 -11 -4 -12 -17
0 -13 -4 -3 -8 22 -5 30 -7 36 -8 18 -2 -34 -5 -34 -41 -7 -16 12 -34 18 -40
15 -12 -8 -71 21 -87 42 -6 8 -16 12 -22 8 -5 -3 -13 0 -15 6 -3 7 -6 -52 -6
-132 -1 -94 -6 -154 -14 -170 -20 -41 -73 -62 -143 -57 -104 8 -124 33 -124
161 0 99 -9 154 -21 134 -6 -9 -9 -6 -10 12 l-1 25 -8 -25 c-7 -21 -8 -22 -9
-5 -1 15 -3 17 -10 6 -7 -10 -26 -12 -90 -6 -44 4 -81 11 -81 17 0 5 -4 7 -9
3 -5 -3 -12 5 -14 17 -3 13 -5 -64 -4 -170 2 -159 0 -188 -10 -165 -9 20 -12
146 -13 464 l0 435 25 51 c32 63 80 107 147 134 47 19 85 22 343 30 159 6 291
12 294 14 17 18 21 -14 19 -157z m3897 124 l130 -7 3 -35 c4 -36 88 -460 141
-710 18 -80 43 -203 57 -275 28 -143 41 -179 79 -229 14 -19 22 -36 18 -38 -9
-5 -376 22 -382 28 -2 2 4 13 14 24 12 13 19 37 20 60 0 39 8 42 19 5 3 -11 3
5 1 35 -3 31 -12 76 -20 101 l-16 46 -141 9 c-163 10 -147 20 -169 -105 -10
-59 -10 -79 0 -105 25 -62 26 -70 6 -62 -11 4 -92 10 -182 13 -90 3 -163 8
-163 11 0 3 11 19 23 36 39 50 43 64 82 236 48 216 70 314 100 435 14 55 41
176 60 269 l35 169 -31 53 -30 54 108 -6 c59 -3 167 -9 238 -12z m-5048 -137
c13 -61 30 -146 38 -190 8 -44 22 -109 30 -145 8 -36 45 -204 80 -374 66 -309
75 -340 114 -385 24 -27 27 -41 9 -41 -7 0 -28 19 -47 41 -32 39 -59 123 -90
284 -5 22 -13 51 -19 65 l-11 25 -2 -30 c-2 -30 -2 -30 -12 8 -6 20 -13 37
-17 37 -4 0 -6 12 -5 28 2 18 1 20 -2 5 -5 -26 -25 -30 -43 -8 -7 8 -21 15
-31 15 -11 0 -19 5 -19 10 0 6 -18 10 -39 10 -29 0 -41 -5 -45 -17 -3 -10 -4
-3 -2 14 1 18 0 30 -3 27 -3 -3 -11 12 -17 33 -18 58 -17 6 1 -64 8 -31 12
-60 7 -64 -4 -4 -63 -9 -132 -11 -95 -2 -124 0 -123 9 2 7 5 45 7 85 3 50 2
60 -3 33 -7 -39 -7 -40 -15 -12 l-8 27 -25 -26 c-19 -21 -30 -25 -54 -20 -17
3 -29 1 -29 -5 0 -6 -4 -7 -10 -4 -16 10 -50 -14 -50 -35 0 -10 -3 -20 -8 -22
-4 -1 -27 -88 -50 -193 -54 -237 -56 -243 -92 -285 -43 -50 -47 -30 -6 32 26
40 40 77 54 148 26 126 106 488 137 620 96 406 94 385 39 437 l-23 21 137 7
c75 3 180 10 232 14 52 5 102 8 110 7 11 -1 21 -32 37 -111z m5603 105 c329
-27 621 -50 635 -50 13 0 15 -24 15 -171 l0 -171 -63 65 -63 65 -68 4 c-37 1
-70 1 -72 -1 -2 -2 -4 -213 -4 -467 l0 -463 40 -57 c22 -32 39 -58 38 -60 -2
-1 -43 2 -93 7 -49 5 -128 13 -175 18 -79 8 -81 8 -30 11 l55 2 -50 8 c-27 4
-62 11 -77 15 -17 4 -28 3 -28 -3 0 -6 10 -13 23 -15 12 -2 1 -5 -26 -6 l-47
-1 40 51 40 51 2 106 2 107 6 -90 6 -90 2 105 c1 72 -1 100 -8 90 -7 -10 -10
32 -9 130 0 80 -3 245 -7 368 l-7 222 -71 1 c-96 2 -92 3 -149 -42 -27 -22
-54 -36 -58 -32 -4 4 -9 74 -11 156 l-3 147 50 0 c28 0 102 -5 165 -10z
m-6410 -189 c0 -83 -4 -152 -9 -155 -4 -3 -17 4 -27 15 -11 12 -38 34 -61 50
l-41 29 -153 -15 c-84 -9 -155 -18 -157 -20 -11 -11 3 -312 14 -324 6 -6 96
-2 172 9 47 6 72 16 102 40 l40 32 0 -151 c0 -83 -4 -151 -9 -151 -4 0 -17 11
-27 25 -14 19 -28 25 -55 25 -32 0 -243 -29 -244 -33 0 -1 1 -80 3 -174 l3
-173 32 0 c65 0 277 29 299 41 12 7 45 34 73 60 l51 49 -3 -113 c-5 -141 -11
-197 -24 -197 -6 0 -9 45 -7 120 2 66 2 120 1 120 0 0 -19 -15 -42 -34 -24
-20 -57 -37 -78 -40 -103 -16 -315 -36 -323 -31 -11 7 -14 343 -4 369 3 9 17
16 30 16 13 0 24 5 24 10 0 6 17 10 38 11 20 0 73 7 117 14 61 11 67 13 25 10
-30 -3 -137 -8 -237 -11 l-182 -7 -6 -26 c-5 -20 -8 -22 -16 -10 -8 12 -10 12
-19 -1 -7 -11 -10 0 -10 39 0 30 -2 52 -5 49 -3 -3 -10 -140 -16 -304 l-9
-298 -28 -43 c-24 -39 -42 -54 -42 -36 0 3 14 30 30 60 l30 53 0 532 0 533
-31 45 -30 45 48 6 c74 10 222 27 393 45 85 8 198 22 250 29 52 7 101 13 108
14 9 1 12 -35 12 -148z m7404 109 c70 -7 165 -17 210 -23 80 -12 81 -12 84
-42 5 -45 43 -233 122 -600 39 -181 80 -375 91 -430 26 -133 36 -160 76 -224
24 -37 29 -52 18 -47 -9 3 -34 9 -56 12 -21 4 -39 11 -39 16 0 5 -4 7 -9 3
-16 -9 -124 7 -109 17 8 5 -14 7 -57 5 -41 -3 -53 -2 -30 2 l40 6 -45 8 c-29
5 -46 4 -48 -3 -4 -10 -32 -14 -32 -4 0 8 42 67 52 75 7 5 -2 60 -30 174 -8
29 -8 30 -112 42 -58 6 -124 14 -146 17 l-42 5 -18 -85 c-18 -88 -17 -94 13
-188 5 -14 2 -17 -13 -13 -28 9 -263 38 -306 39 -41 0 -47 8 -23 28 27 22 55
77 71 137 35 127 45 169 49 192 4 29 37 174 71 319 38 158 86 392 92 440 3 37
-1 50 -27 87 -32 44 -31 60 4 51 11 -3 78 -10 149 -16z m-6987 -712 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m303 -226 c6 -33 10 -67 8 -78 -2
-10 -10 14 -17 54 l-14 73 -91 -4 c-64 -3 -75 -2 -36 3 30 3 74 7 96 8 l41 2
13 -58z m-307 11 c-2 -16 -11 -67 -20 -115 -15 -80 -15 -87 0 -103 10 -9 22
-25 27 -36 16 -28 -16 -25 -41 4 -23 27 -23 50 -3 152 9 44 18 90 20 103 6 32
22 27 17 -5z m3230 -30 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23
-4z m54 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-2509 -99
c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m-456 -87 c-17 -38
-32 -49 -32 -25 0 7 7 22 15 33 8 10 15 37 16 59 l1 40 9 -35 c6 -26 4 -44 -9
-72z m4241 85 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-1258
-36 c28 -2 -105 -3 -295 -3 -259 0 -299 2 -160 6 174 5 341 4 455 -3z m-1794
-25 c-7 -2 -18 1 -23 6 -8 8 -4 9 13 5 13 -4 18 -8 10 -11z m652 11 c-7 -2
-19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m908 -50 c67 -110 91 -134 189
-183 l95 -48 -108 -7 c-59 -4 -135 -5 -170 -1 -34 3 -101 9 -149 12 -49 4 -88
11 -88 15 0 5 -5 9 -11 9 -5 0 -7 -4 -4 -10 4 -6 -6 -10 -22 -9 -24 0 -19 5
33 30 75 36 101 61 161 156 26 40 48 73 49 73 1 0 13 -17 25 -37z m-2458 0
c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m-730 -50 c-13 -2 -35
-2 -50 0 -16 2 -5 4 22 4 28 0 40 -2 28 -4z m-105 -10 c-10 -2 -26 -2 -35 0
-10 3 -2 5 17 5 19 0 27 -2 18 -5z m-425 -40 c-7 -2 -21 -2 -30 0 -10 3 -4 5
12 5 17 0 24 -2 18 -5z m-70 -10 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19
-2 13 -5z m-86 -9 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m-254 -31 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m3636 -42
l-44 -39 -655 -6 c-360 -3 -740 -8 -844 -11 -104 -3 -187 -3 -184 0 2 3 83 10
179 16 96 6 194 13 219 14 261 19 1361 74 1369 68 2 -1 -16 -20 -40 -42z
m1371 29 c427 -15 904 -38 1140 -55 113 -8 318 -22 455 -30 283 -17 388 -26
382 -32 -3 -2 -200 3 -439 12 -239 9 -765 19 -1169 23 l-734 7 -52 40 c-29 21
-53 42 -53 45 0 3 39 5 88 3 48 -1 220 -7 382 -13z m-5067 3 c-7 -2 -19 -2
-25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m447 -453 c0 -39 -1 -40 -35 -40 l-35
0 0 -173 0 -173 -40 4 -40 4 0 169 0 169 -35 0 c-33 0 -35 2 -35 33 0 19 3 37
7 40 3 4 53 7 110 7 l103 0 0 -40z m148 -47 c3 -80 4 -83 27 -83 23 0 24 3 27
83 l3 82 40 0 40 0 3 -207 2 -208 -45 0 -45 0 0 85 c0 84 0 85 -25 85 -24 0
-25 -3 -26 -60 -1 -33 -3 -64 -4 -70 -1 -5 -3 -17 -4 -25 -1 -11 -13 -15 -41
-15 l-40 0 0 203 c0 112 3 207 7 211 4 4 23 6 43 4 l35 -3 3 -82z m402 47 l0
-40 -51 0 -50 0 3 -42 c3 -42 4 -43 41 -46 35 -3 37 -5 37 -38 0 -35 2 -34
-60 -38 -11 -1 -16 -15 -18 -48 l-3 -48 50 0 51 0 0 -40 0 -40 -95 0 -95 0 0
203 c0 112 3 207 7 210 3 4 46 7 95 7 l88 0 0 -40z m334 31 c3 -4 13 -54 22
-110 10 -56 19 -99 22 -97 2 3 12 51 21 108 l18 103 59 0 59 0 3 -207 2 -208
-45 0 -45 0 -1 118 -1 117 -14 -70 c-7 -38 -16 -91 -20 -117 -6 -46 -8 -48
-39 -48 l-33 0 -18 118 -19 117 -5 -115 -5 -115 -37 -3 -38 -3 0 210 0 211 54
0 c30 0 57 -4 60 -9z m461 -7 c36 -23 45 -65 45 -201 0 -142 -10 -171 -64
-197 -42 -20 -57 -20 -101 -2 -55 23 -65 56 -65 206 0 135 6 160 43 193 26 22
109 23 142 1z m296 -13 c21 -22 29 -39 29 -65 0 -35 -1 -36 -40 -36 -32 0 -40
4 -40 19 0 22 -25 45 -40 36 -26 -16 -9 -54 49 -104 68 -59 86 -95 78 -152
-10 -75 -76 -114 -151 -89 -40 13 -76 62 -76 104 0 24 3 26 44 26 41 0 45 -2
48 -27 2 -20 9 -29 26 -31 19 -3 22 1 22 28 0 26 -11 42 -60 87 -70 65 -89
110 -71 164 14 43 54 68 109 69 35 0 49 -6 73 -29z m299 -11 c0 -38 -2 -40
-30 -40 l-30 0 -2 -167 -3 -168 -42 -3 -43 -3 0 170 0 171 -35 0 c-34 0 -35 1
-35 40 l0 40 110 0 110 0 0 -40z m385 25 c41 -20 55 -51 55 -125 0 -77 -32
-118 -97 -127 l-43 -6 0 -73 0 -74 -45 0 -45 0 0 203 c0 112 3 207 7 210 13
13 135 7 168 -8z m301 -3 c38 -30 44 -56 44 -192 0 -149 -9 -178 -64 -204 -42
-20 -57 -20 -101 -2 -55 23 -65 56 -65 206 0 180 16 208 120 209 28 0 53 -6
66 -17z m188 -6 c3 -13 9 -62 12 -110 4 -48 10 -89 14 -91 5 -3 13 34 20 83
19 150 16 142 61 142 21 0 39 -1 40 -2 0 -2 8 -55 18 -118 19 -125 21 -123 43
25 l13 90 38 3 c49 4 49 14 -9 -320 l-17 -98 -47 0 -47 0 -13 106 c-7 58 -16
102 -20 97 -5 -4 -14 -51 -22 -103 l-13 -95 -47 -3 c-27 -2 -48 1 -48 5 0 4
-15 96 -34 203 -19 107 -32 198 -29 203 2 4 21 7 43 7 31 0 39 -4 44 -24z
m540 -16 c0 -35 -1 -35 -47 -38 l-47 -3 0 -45 0 -44 41 0 40 0 -3 -37 c-3 -36
-5 -38 -38 -38 -35 -1 -35 -2 -38 -48 l-3 -47 50 0 51 0 0 -40 0 -40 -95 0
-95 0 0 210 0 211 92 -3 92 -3 0 -35z m257 13 c16 -15 24 -38 27 -77 5 -65 -2
-98 -25 -121 -16 -16 -15 -22 10 -94 36 -101 36 -103 -15 -99 l-42 3 -24 78
c-14 43 -26 76 -28 75 -1 -2 -4 -37 -7 -78 l-3 -75 -42 -3 -42 -3 0 211 0 212
85 -3 c71 -3 88 -8 106 -26z m279 -13 l0 -40 -45 0 -45 0 0 -45 0 -45 40 0 40
0 0 -40 0 -40 -40 0 -40 0 0 -85 0 -85 -45 0 -45 0 0 203 c0 112 3 207 7 210
3 4 44 7 90 7 l83 0 0 -40z m148 -133 c2 -142 5 -169 18 -174 9 -3 20 0 25 8
5 8 9 87 9 177 l0 163 43 -3 42 -3 3 -162 c3 -192 -5 -225 -65 -249 -55 -23
-110 -9 -140 35 -22 32 -23 43 -23 208 l0 174 43 -3 42 -3 3 -168z m302 3 l0
-170 44 0 c47 0 56 -11 48 -57 -4 -22 -9 -23 -93 -23 l-89 0 0 210 0 210 45 0
45 0 0 -170z m482 155 c38 -15 52 -56 56 -165 5 -120 -7 -176 -43 -210 -21
-19 -38 -24 -105 -28 l-80 -5 0 213 0 213 78 -6 c42 -3 85 -8 94 -12z m292
-52 c15 -68 66 -331 66 -345 0 -5 -16 -8 -35 -8 -36 0 -38 3 -49 53 -5 23 -11
27 -40 27 -31 0 -35 -3 -43 -37 -8 -35 -12 -38 -47 -41 -37 -3 -38 -2 -33 25
3 15 20 108 38 205 32 172 33 177 58 181 69 11 68 12 85 -60z m301 27 c0 -32
-3 -35 -32 -38 l-33 -3 0 -170 0 -169 -40 0 -40 0 0 170 0 170 -35 0 c-34 0
-35 1 -35 40 l0 41 108 -3 107 -3 0 -35z m191 32 c10 -6 84 -358 84 -397 0
-11 -11 -15 -39 -15 -37 0 -39 1 -45 40 -5 34 -10 40 -30 40 -44 0 -56 -10
-56 -46 0 -33 -1 -34 -40 -34 -36 0 -40 2 -40 25 0 14 6 54 14 88 8 34 22 109
32 167 21 132 25 140 72 140 20 0 42 -4 48 -8z m380 0 c6 -4 23 -46 39 -94 15
-49 30 -88 34 -88 3 0 6 42 6 92 l0 93 38 3 37 3 0 -211 0 -211 -37 3 -36 3
-36 100 -36 100 -3 -102 -3 -103 -33 0 c-29 0 -34 4 -39 28 -8 41 -9 377 -1
385 9 9 56 9 70 -1z m414 -32 l0 -40 -43 0 c-24 0 -46 -2 -48 -4 -3 -3 -3 -23
-1 -45 4 -40 5 -41 43 -41 38 0 39 -1 39 -34 0 -34 -1 -35 -42 -38 l-41 -3 0
-45 0 -45 52 -3 52 -3 -3 -37 -3 -37 -90 0 -90 0 -3 193 c-2 107 -1 200 2 208
4 10 27 14 91 14 l85 0 0 -40z m265 0 c0 -31 -3 -35 -30 -40 l-30 -5 -3 -168
-2 -167 -40 0 -40 0 0 169 0 170 -32 3 c-26 2 -34 8 -36 26 -7 50 0 53 110 50
l103 -3 0 -35z m131 15 c1 -11 8 -67 15 -125 14 -117 13 -120 41 65 l13 80 33
3 c39 4 38 5 62 -135 9 -59 20 -101 23 -93 3 8 10 59 16 114 6 54 14 103 17
107 3 5 21 9 40 9 28 0 34 -4 34 -21 0 -28 -60 -380 -66 -391 -9 -14 -81 -9
-87 5 -3 8 -11 57 -18 110 -7 53 -15 94 -19 92 -4 -2 -13 -52 -19 -110 l-13
-105 -44 0 c-24 0 -44 2 -44 4 0 2 -13 78 -29 167 -48 268 -48 252 8 247 25
-2 35 -8 37 -23z m531 5 c18 -11 35 -30 39 -43 3 -14 4 -89 2 -167 -3 -141 -3
-142 -31 -166 -22 -18 -40 -24 -79 -24 -43 0 -54 4 -79 31 l-29 31 0 148 c0
145 1 149 26 179 22 27 33 31 72 31 29 0 59 -8 79 -20z m282 9 c40 -14 61 -54
61 -119 0 -51 -13 -88 -34 -102 -8 -5 -2 -31 17 -85 15 -43 27 -84 27 -90 0
-8 -15 -13 -40 -13 l-39 0 -24 77 c-33 104 -47 105 -47 4 l0 -81 -40 0 -40 0
0 210 0 210 64 0 c34 0 77 -5 95 -11z m221 -66 l1 -78 32 75 c33 75 33 75 75
78 23 2 42 1 42 -2 0 -3 -18 -45 -40 -93 l-41 -87 46 -113 c25 -62 45 -115 45
-118 0 -11 -78 -4 -88 8 -5 6 -20 40 -32 75 -13 34 -27 62 -31 62 -5 0 -9 -34
-9 -75 l0 -75 -40 0 -39 0 -3 206 c-2 113 -1 208 1 210 2 2 22 4 43 4 l38 0 0
-77z"
          />
          <path
            d="M3435 3619 c-5 -5 -19 -17 -30 -25 -17 -13 -16 -13 12 0 17 9 35 20
38 26 8 13 -7 12 -20 -1z"
          />
          <path d="M3345 3560 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
          <path d="M1373 2933 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
          <path d="M1018 2893 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M6668 2660 c-1 -5 -2 -203 0 -440 l2 -430 65 0 c146 0 145 -4 145
432 0 201 -4 358 -10 379 -8 27 -19 41 -44 53 -38 18 -152 22 -158 6z"
          />
          <path
            d="M7701 2550 c-1 -3 -21 -115 -46 -250 -25 -135 -45 -250 -45 -256 0
-12 181 -28 192 -16 8 9 -24 226 -45 307 -9 33 -25 96 -36 140 -10 44 -20 78
-20 75z"
          />
          <path d="M7291 1694 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M7262 1630 l-21 -28 105 -1 c71 -1 104 2 99 9 -3 5 -21 10 -40 10
-18 0 -53 9 -78 19 l-45 19 -20 -28z"
          />
          <path
            d="M7903 1608 c4 -11 -1 -18 -16 -22 -35 -9 -17 -14 71 -18 96 -5 122 7
31 14 -45 3 -66 10 -77 24 -11 14 -13 15 -9 2z"
          />
          <path
            d="M2491 2532 c-1 -18 -5 -52 -11 -75 -23 -101 -82 -458 -77 -463 3 -3
49 -3 102 1 92 7 96 9 91 29 -3 11 -26 134 -51 271 -49 269 -53 287 -54 237z"
          />
          <path d="M2221 2094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M2841 2014 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M8588 1523 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
          <path d="M1613 2053 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
          <path
            d="M9410 2384 c0 -3 -20 -112 -45 -242 -31 -164 -42 -238 -34 -243 14
-9 177 -22 188 -15 14 9 4 75 -56 344 -20 89 -40 162 -45 162 -4 0 -8 -3 -8
-6z"
          />
          <path
            d="M5233 1379 c-36 -23 -40 -29 -20 -29 14 0 76 49 62 49 -5 1 -25 -9
-42 -20z"
          />
          <path
            d="M2937 914 c-4 -4 -7 -68 -7 -141 0 -134 0 -134 23 -131 22 3 22 6 22
138 0 114 -2 135 -15 138 -9 1 -19 0 -23 -4z"
          />
          <path
            d="M3926 913 c-10 -10 -7 -123 3 -123 32 0 41 14 41 61 0 37 -4 51 -19
58 -10 6 -21 7 -25 4z"
          />
          <path
            d="M4216 908 c-10 -30 -15 -154 -9 -210 5 -53 8 -59 27 -56 20 3 21 8
21 138 0 120 -2 135 -18 138 -9 2 -19 -2 -21 -10z"
          />
          <path
            d="M5190 860 c0 -53 2 -58 20 -53 16 4 20 14 20 53 0 39 -4 49 -20 53
-18 5 -20 0 -20 -53z"
          />
          <path
            d="M6417 913 c-4 -3 -7 -66 -7 -140 0 -121 2 -133 18 -133 36 0 42 20
42 142 0 106 -2 118 -19 128 -23 12 -26 12 -34 3z"
          />
          <path
            d="M6727 840 c-3 -14 -8 -46 -11 -72 -5 -46 -5 -48 19 -48 14 0 25 3 24
8 0 4 -6 36 -13 72 -10 50 -14 59 -19 40z"
          />
          <path
            d="M7238 850 c-4 -19 -10 -56 -14 -82 -6 -47 -6 -48 20 -48 22 0 26 3
21 23 -3 12 -9 49 -13 82 -7 56 -8 58 -14 25z"
          />
          <path
            d="M8917 913 c-4 -3 -7 -66 -7 -140 l0 -133 24 0 c32 0 36 14 36 140 0
60 -3 115 -6 124 -6 16 -35 22 -47 9z"
          />
          <path
            d="M9212 858 c3 -45 6 -53 23 -53 24 0 41 41 31 79 -5 19 -13 26 -32 26
-24 0 -25 -2 -22 -52z"
          />
          <path
            d="M4198 9573 c-10 -2 -18 -9 -18 -14 0 -13 12 -11 34 6 20 15 16 17
-16 8z"
          />
          <path
            d="M4160 9562 c0 -6 -8 -13 -17 -15 -16 -4 -16 -5 -1 -6 18 -1 34 16 24
26 -3 4 -6 1 -6 -5z"
          />
          <path d="M4038 9513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M4130 9503 c-25 -8 -58 -20 -75 -28 -16 -7 -48 -20 -69 -29 -29 -12
-37 -19 -29 -27 8 -8 37 -3 105 21 94 33 123 50 117 68 -3 6 -21 5 -49 -5z"
          />
          <path
            d="M9056 8459 c-2 -8 -7 -32 -11 -54 -3 -22 -18 -80 -32 -128 l-26 -88
21 -27 c104 -133 245 -358 335 -533 224 -437 358 -914 407 -1444 13 -143 13
-487 0 -651 -64 -791 -368 -1555 -867 -2175 -29 -36 -53 -71 -53 -76 0 -6 51
-15 113 -20 l112 -10 28 31 c161 176 413 577 541 863 347 774 449 1625 296
2483 -53 298 -144 599 -275 905 -38 89 -170 344 -227 439 -78 130 -195 301
-271 396 -86 107 -85 106 -91 89z m476 -729 c52 -102 104 -207 115 -235 181
-421 288 -887 313 -1362 12 -230 12 -293 2 -293 -5 0 -14 89 -21 198 -42 667
-164 1159 -414 1672 -102 210 -109 226 -98 215 5 -5 51 -93 103 -195z m425
-1992 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"
          />
          <path
            d="M8943 8077 c-11 -23 -48 -80 -83 -126 -70 -94 -70 -87 -6 -185 125
-192 243 -421 326 -631 65 -165 165 -510 183 -630 3 -16 14 -91 26 -165 30
-187 51 -439 51 -605 0 -309 -50 -684 -132 -995 -11 -41 -24 -88 -28 -105 -72
-275 -273 -713 -438 -950 -78 -111 -201 -275 -264 -348 -63 -74 -210 -230
-220 -235 -5 -2 -8 -8 -8 -13 0 -5 30 -9 67 -9 62 0 66 1 47 16 -19 15 -18 15
3 11 13 -3 26 -1 29 4 3 5 0 9 -5 9 -6 0 -11 5 -11 10 0 6 8 10 18 10 11 0 27
9 38 21 10 11 28 26 39 31 20 11 20 11 0 -11 -15 -18 -16 -24 -6 -30 10 -7 11
-13 1 -32 -9 -18 -2 -14 26 14 32 31 36 39 24 47 -8 5 -11 12 -7 17 5 4 12 1
17 -7 8 -12 19 -5 57 36 69 74 123 136 123 143 0 3 15 22 33 41 62 68 257 337
257 356 0 3 11 20 24 37 13 18 50 82 81 142 32 61 62 116 69 124 9 11 8 13 -4
9 -8 -2 -19 -14 -25 -26 -14 -31 -28 -27 -20 5 9 37 -6 21 -20 -21 -8 -23 -9
-40 -2 -51 6 -12 6 -16 -1 -11 -13 8 -22 -6 -42 -63 -8 -25 -22 -47 -30 -49
-12 -4 -12 -1 2 19 8 14 19 44 23 69 4 25 14 55 23 67 10 16 13 37 9 65 -4 27
-2 37 3 27 7 -11 12 -7 21 19 6 18 18 32 27 33 11 0 12 2 5 6 -7 2 -13 12 -13
20 0 19 52 137 62 141 4 2 8 14 8 26 0 13 3 26 8 30 4 4 7 11 8 14 0 4 4 14 7
22 24 58 90 261 132 405 57 196 110 501 124 700 20 314 11 673 -24 910 -29
196 -87 480 -105 515 -14 28 -21 90 -10 90 16 0 12 30 -5 36 -12 5 -14 16 -9
53 4 29 0 68 -10 106 -9 35 -12 63 -6 69 11 11 -4 49 -103 256 -52 109 -181
346 -197 360 -3 3 -32 44 -64 93 -33 48 -64 91 -71 97 -8 7 -17 -3 -32 -33z
m583 -2879 c-3 -7 -12 -46 -21 -86 -10 -40 -19 -71 -22 -68 -3 2 3 32 11 66 9
34 16 70 16 81 0 10 4 19 10 19 5 0 8 -6 6 -12z m-49 -190 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-22 -110 c-10 -40 -24 -84 -32 -98 -9 -15
-11 -17 -7 -5 6 17 19 72 40 164 3 13 8 21 11 18 3 -3 -3 -39 -12 -79z m-79
-258 c-64 -195 -175 -449 -269 -615 -77 -136 -242 -381 -308 -455 -28 -33 -29
-33 -12 -5 9 17 23 34 30 38 7 4 13 14 13 22 0 7 4 15 8 17 25 9 243 357 315
503 101 203 245 557 248 612 1 13 2 14 5 3 3 -9 -11 -63 -30 -120z m-196 -584
c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-99
-280 c-11 -27 -24 -37 -16 -11 3 8 7 22 10 31 3 9 8 15 11 12 2 -3 0 -17 -5
-32z m-91 -147 c-7 -11 -14 -18 -17 -15 -8 8 5 36 17 36 7 0 7 -6 0 -21z m-40
-49 c0 -5 -4 -10 -9 -10 -5 0 -12 -10 -16 -22 -6 -19 -8 -20 -12 -6 -2 10 2
24 9 32 15 18 28 20 28 6z m-190 -65 c-7 -9 -15 -13 -19 -10 -3 3 1 10 9 15
21 14 24 12 10 -5z m-39 -42 c-12 -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0
-13 -6 -23z m124 -32 c-10 -40 -65 -83 -65 -51 0 6 5 9 11 8 6 -2 14 3 17 11
3 8 0 11 -7 7 -6 -4 -11 0 -11 9 0 12 6 15 23 11 12 -3 17 -3 10 0 -9 4 -10
10 -1 24 16 26 31 14 23 -19z m-123 -104 c-5 -20 -4 -21 11 -8 9 7 17 9 17 3
0 -5 -7 -15 -15 -22 -8 -7 -15 -9 -15 -6 0 4 -9 2 -20 -4 -27 -15 -27 10 0 35
11 10 17 22 13 28 -3 5 -1 7 5 4 5 -4 8 -17 4 -30z m73 23 c-3 -5 -14 -10 -23
-9 -14 0 -13 2 3 9 27 11 27 11 20 0z m-100 -100 c-10 -11 -20 -18 -23 -15 -7
6 18 35 31 35 5 0 2 -9 -8 -20z m-90 -100 c-3 -5 -10 -10 -16 -10 -5 0 -9 5
-9 10 0 6 7 10 16 10 8 0 12 -4 9 -10z"
          />
          <path
            d="M7700 7343 c0 -1 14 -10 31 -18 19 -10 29 -22 25 -31 -4 -10 7 -17
39 -25 34 -8 64 -29 115 -76 59 -56 72 -74 90 -129 11 -35 20 -69 20 -76 0 -7
12 -24 25 -37 31 -29 32 -41 1 -41 -13 0 -26 -6 -29 -13 -6 -17 20 -95 44
-129 24 -34 24 -58 0 -58 -35 0 -53 -11 -41 -25 30 -36 -111 -45 -150 -10 -20
17 -160 29 -180 15 -13 -9 -13 -11 0 -20 23 -15 -7 -13 -114 8 l-91 17 60 5
60 5 -56 14 c-49 12 -59 11 -87 -3 -17 -9 -43 -16 -59 -16 -23 0 -25 -2 -13
-13 8 -8 62 -19 120 -26 116 -14 190 -28 152 -30 -18 -1 -22 -5 -17 -20 5 -16
-1 -22 -33 -32 -39 -11 -39 -12 -20 -31 10 -10 23 -16 28 -13 5 3 11 1 14 -4
3 -5 -22 -21 -57 -35 l-62 -26 65 3 c60 2 65 0 68 -20 2 -12 10 -27 18 -33 18
-15 18 -30 1 -30 -20 0 -61 -47 -48 -55 6 -3 11 -20 11 -36 0 -29 2 -30 31
-24 38 8 50 -6 42 -47 -4 -19 0 -35 11 -46 8 -10 21 -33 27 -51 10 -29 13 -31
28 -17 10 9 25 16 34 16 9 0 21 8 26 18 7 11 10 13 11 3 0 -22 27 5 34 35 5
18 12 24 22 20 10 -4 18 1 21 14 3 11 9 20 13 20 4 0 11 10 15 23 4 13 8 17
12 9 3 -8 12 -3 26 15 29 40 80 93 88 93 4 0 1 -17 -6 -37 -17 -50 -7 -65 16
-22 21 42 69 89 69 68 1 -10 6 -8 18 6 29 35 83 60 177 84 l91 24 79 -50 c44
-28 108 -61 142 -74 76 -29 79 -43 27 -137 l-35 -65 33 7 c84 17 193 99 233
176 20 39 14 49 -10 16 -16 -22 -19 -22 -36 -7 -11 8 -19 23 -19 33 0 24 -22
71 -37 81 -7 4 -13 15 -13 23 0 41 -148 224 -182 224 -23 0 -23 9 0 26 10 8
12 13 5 14 -7 0 -22 -9 -34 -21 -11 -11 -23 -18 -26 -15 -3 2 -16 0 -30 -5
-25 -9 -25 -9 -11 13 9 13 30 32 48 42 27 16 36 17 52 7 15 -9 19 -9 16 1 -1
7 17 32 41 56 51 49 43 56 -15 12 -21 -16 -46 -30 -56 -30 -32 0 -97 -43 -109
-72 -10 -25 -14 -27 -28 -15 -19 16 -135 72 -171 83 -50 14 14 23 84 11 69
-12 121 -2 157 30 14 12 17 12 22 -2 14 -36 107 -9 107 31 0 23 -43 38 -69 25
-17 -10 -21 -9 -21 4 0 8 -4 15 -9 15 -16 0 -23 52 -9 61 9 6 6 9 -9 9 -31 0
-170 47 -211 71 -18 10 -52 35 -75 54 -58 47 -152 95 -176 88 -20 -5 -112 34
-210 89 -43 25 -66 31 -117 32 -35 1 -64 1 -64 -1z m543 -317 c37 0 37 0 18
-19 -24 -24 -65 -17 -82 15 -10 19 -9 20 7 12 11 -4 36 -8 57 -8z m-81 -167
c23 -12 69 -32 102 -45 87 -33 56 -29 -49 6 -50 17 -98 33 -107 36 -28 10 -22
-19 10 -49 15 -14 52 -40 82 -56 71 -39 57 -40 -18 -1 -69 36 -85 48 -101 78
-28 52 11 67 81 31z m477 -161 c0 -16 -2 -18 -6 -8 -3 8 -11 18 -17 22 -7 5
-4 8 7 8 11 0 17 -7 16 -22z m-313 -19 c3 -6 -5 -3 -20 6 -14 10 -26 19 -26
22 0 7 39 -17 46 -28z"
          />
          <path d="M7158 7113 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path
            d="M7283 7070 c18 -14 40 -20 78 -20 67 0 54 15 -25 29 -80 15 -83 14
-53 -9z"
          />
          <path d="M8796 6985 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
          <path
            d="M7440 6930 c0 -5 16 -10 36 -10 21 0 33 4 29 10 -3 6 -19 10 -36 10
-16 0 -29 -4 -29 -10z"
          />
          <path d="M7528 6823 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path
            d="M8650 6800 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"
          />
          <path
            d="M6886 6704 c-26 -26 -18 -39 9 -14 14 13 25 25 25 27 0 9 -20 1 -34
-13z"
          />
          <path d="M7618 6693 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M7383 6563 c-13 -2 -23 -8 -23 -13 0 -8 69 6 79 16 5 5 -25 3 -56 -3z" />
          <path
            d="M7245 6290 c-17 -33 -18 -40 -7 -40 5 0 16 16 25 35 20 42 4 47 -18
5z"
          />
          <path
            d="M7995 6259 c-9 -16 -20 -71 -25 -122 -8 -89 -8 -93 16 -116 29 -31
36 -25 25 20 -13 50 -22 158 -11 134 8 -20 9 -19 9 1 1 12 8 38 16 57 18 44
18 44 0 51 -10 3 -20 -5 -30 -25z"
          />
          <path
            d="M7925 6053 c-3 -27 -13 -75 -21 -107 -13 -48 -13 -60 -2 -67 14 -9
30 50 42 162 8 71 -9 81 -19 12z"
          />
          <path
            d="M7953 4252 c-6 -4 11 -7 37 -7 26 0 43 3 37 7 -7 4 -23 8 -37 8 -14
0 -30 -4 -37 -8z"
          />
          <path d="M7705 4240 c-4 -6 7 -10 27 -10 25 0 29 3 18 10 -19 13 -37 13 -45 0z" />
          <path
            d="M9307 4160 c-5 -17 -9 -21 -15 -13 -5 8 -8 -1 -8 -23 l0 -35 19 36
c10 20 16 42 14 48 -2 6 -7 0 -10 -13z"
          />
          <path
            d="M8698 3146 c-83 -87 -84 -96 -8 -96 99 -1 901 -88 1200 -131 80 -12
162 -19 183 -16 49 7 268 88 262 97 -3 4 -21 10 -42 13 -21 3 -126 20 -233 37
-286 45 -884 129 -1175 164 l-110 14 -77 -82z"
          />
          <path d="M8520 3124 c0 -9 7 -14 17 -12 25 5 28 28 4 28 -12 0 -21 -6 -21 -16z" />
          <path
            d="M9655 2870 c22 -5 72 -11 110 -13 l70 -6 -80 14 c-88 15 -173 19
-100 5z"
          />
          <path d="M9848 2843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
